import { useStorageFetchBadgeWithAllRelations } from '../../../../../ui/features/badge-management/hooks/useStorageFetchBadgeWithAllRelations';
import { manageBadgesRoutes } from '../../../../../ui/features/badge-management/utils/manageBadgesRoutes';
import { CircularProgress } from '@mui/material';
import React from 'react';
import { Navigate, useParams } from 'react-router';
export const BadgeDuplicatePage = ({ BadgeCreateComponent, }) => {
    const { badgeId } = useParams();
    const { badge, accountBadges, accounts, isLoading } = useStorageFetchBadgeWithAllRelations({ badgeId });
    if (isLoading) {
        return React.createElement(CircularProgress, null);
    }
    if (!badge) {
        return React.createElement(Navigate, { to: manageBadgesRoutes.home('manage-badges', { base: '../' }), replace: true });
    }
    const accountSelectionsToDuplicate = accountBadges.rows.flatMap((accountBadge) => {
        const account = accounts.rows.find((a) => a.id === accountBadge.columns.accountId);
        if (!account) {
            return [];
        }
        return {
            id: account.id,
            account: account.columns,
            options: {
                organizationId: accountBadge.columns.organizationId,
            },
            accountBadge,
        };
    });
    return (React.createElement(BadgeCreateComponent, { badgeTemplate: badge.data.templateSnapshot, badgeToDuplicate: badge, accountSelectionsToDuplicate: accountSelectionsToDuplicate }));
};
